import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// components
import { EditDocumentComponent } from './components/edit-document/edit-document.component';
import { LoginComponent } from './components/login/login.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { LoggedOutComponent } from './components/logged-out/logged-out.component';
import { TimedOutComponent } from './components/timed-out/timed-out.component';
import { SessionPageComponent } from './components/session-page/session-page.component';

// guards
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { UnauthenticatedGuard } from './guards/unauthenticated.guard';
import { ContentUpdateComponent } from './components/content-update/content-update.component';

const routes: Routes = [
  { path: '', component: EditDocumentComponent, canActivate: [AuthenticatedGuard] },
  { path: 'sessions', component: SessionPageComponent, canActivate: [AuthenticatedGuard] },
  { path: 'login', component: LoginComponent, canActivate: [UnauthenticatedGuard] },
  { path: 'pdf', component: PdfViewerComponent, canActivate: [AuthenticatedGuard] },
  { path: 'loggedout', component: LoggedOutComponent },
  { path: 'timedout', component: TimedOutComponent },
  { path: 'content-update', component: ContentUpdateComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
